import { render, staticRenderFns } from "./ModalRank.vue?vue&type=template&id=2df5a6d4&scoped=true"
import script from "./ModalRank.vue?vue&type=script&lang=ts"
export * from "./ModalRank.vue?vue&type=script&lang=ts"
import style0 from "./ModalRank.vue?vue&type=style&index=0&id=2df5a6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5a6d4",
  null
  
)

export default component.exports